import type { ChatSidebarMode } from '@/contexts/ChatSidebarContextDef';
import { useAuth } from '@/hooks/useAuth';
import { ChatConversation, ChatMessage } from '@/hooks/useChat';

import { ChatMessagesArea } from './ChatMessagesArea';
import { ChatSidebarHeader } from './ChatSidebarHeader';
import { ContextSelectionItem } from './ContextSelectionContext';
import type { FileContext } from './parseAttachedFiles';

interface ChatSidebarContentProps {
  conversations: ChatConversation[];
  currentConversationId: string | null;
  messages: ChatMessage[];
  showEmptyState: boolean;
  isLoading: boolean;
  isResponding: boolean;
  pendingAssistantForMessageId: string | null;
  mode: ChatSidebarMode;
  onNewConversation: () => Promise<unknown>;
  onConversationSelect: (id: string) => void;
  onSendMessage: (
    message: string,
    contextSelection?: ContextSelectionItem[],
    fileContexts?: FileContext[]
  ) => Promise<boolean>;
  onSwitchMode: () => void;
  onClose: () => void;
  onStopResponding?: () => void;
}

export const ChatSidebarContent = (props: ChatSidebarContentProps) => {
  const { user, isLoaded } = useAuth();

  return (
    <div className="flex flex-col h-full min-h-0">
      <ChatSidebarHeader
        conversations={props.conversations}
        currentConversationId={props.currentConversationId}
        mode={props.mode}
        showEmptyState={props.showEmptyState}
        onNewConversation={props.onNewConversation}
        onConversationSelect={props.onConversationSelect}
        onSwitchMode={props.onSwitchMode}
        onClose={props.onClose}
      />

      <ChatMessagesArea
        messages={props.messages}
        showEmptyState={props.showEmptyState}
        isMessageInputDisabled={
          !isLoaded || props.isLoading || props.isResponding
        }
        isResponding={props.isResponding}
        currentConversationId={props.currentConversationId}
        userName={user?.firstName}
        mode={props.mode}
        onSendMessage={props.onSendMessage}
        onStopResponding={props.onStopResponding}
        onEnsureConversation={props.onNewConversation}
      />
    </div>
  );
};
